import React from "react";
import { withRouter } from "react-router-dom";
import { Grid, Button } from "@material-ui/core";
import { TextLabel } from "../../shared/components";
import { Trans } from "adapters/i18n";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.clear();
    console.log(`Ocorreu um erro na renderização`);
    console.log("Error :", error);
    console.log("ErrorInfo :", errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          style={{ height: "100vh", width: "100vw" }}
        >
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="center"
              style={{ height: 100, width: "25%" }}
            >
              <TextLabel>
                <Trans i18nKey="errors:general.unexpected-error" />
              </TextLabel>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.props.history.replace("/")}
              >
                <Trans i18nKey="common:actions.go-back-to-homepage" />
              </Button>
            </Grid>
          </Grid>
        </Grid>
      );
    }

    return this.props.children;
  }
}

export default withRouter(ErrorBoundary);
